// // src/components/chat/ChatMessage.jsx
// import React from "react";

// export default function ChatMessage({ message }) {
//   const alignment = message.fromMe ? "items-end" : "items-start";
//   const bubble =
//     "inline-block px-3 py-2 rounded-2xl text-sm " +
//     (message.fromMe
//       ? "bg-[#FF4A1F] text-white rounded-br-none"
//       : "bg-white text-gray-800 border rounded-bl-none");

//   return (
//     <div className={`flex ${alignment} mb-2`}>
//       <div className={bubble}>{message.text}</div>
//     </div>
//   );
// }












// src/components/chat/ChatMessage.jsx
import React from "react";

export default function ChatMessage({ fromMe, text, createdAt }) {
  const containerClass = fromMe ? "justify-end" : "justify-start";
  const bubbleClass = fromMe
    ? "bg-primary text-white rounded-br-none"
    : "bg-white text-gray-800 border rounded-bl-none";

  return (
    <div className={`flex ${containerClass} mb-2`}>
      <div
        className={`max-w-[70%] inline-block px-3 py-2 rounded-2xl text-sm ${bubbleClass}`}
      >
        <div>{text}</div>
        {createdAt && (
          <div className="mt-1 text-[10px] text-gray-400 text-right">
            {new Date(createdAt).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </div>
        )}
      </div>
    </div>
  );
}
